/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-标签管理-二级标签
 */
'use strict';
angular.module("twoLevelClassifiyModule", []).
controller('twoLevelClassifiyCtrl', ['$scope', '$stateParams', 'httpService', 'modalDialog', function($scope, $stateParams, httpService, modalDialog) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			inputData: ''
		}
		$scope.platformName = "石榴云";
		$scope.data = {
			classId: $stateParams.classId,
			className:$stateParams.className,
			selectedArray: [] //选中的数据
		}
		$scope.page = {
			"CURRPAGE": 1,
			"PAGESIZE": 20,
			"ITEMCOUNT": 0
		};
		initDropDownList();
	};

	function initData() {
		requestData();
	};
	/**
	 * [selectClass description] 单选
	 * @param  {[type]} item [description] 当前数据
	 * @return {[type]}      [description]
	 */
	$scope.selectClass = function(item) {
		var index = $scope.data.selectedArray.indexOf(item);
		index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
	};
	/**
	 * [selectPanel description] 全选当前面板的稿件
	 * @param  {[type]} items [description] 当前面板
	 * @return {[type]}       [description]
	 */
	$scope.selectPanel = function(items) {
		if($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
			$scope.data.selectedArray = [];
		} else {
			$scope.data.selectedArray = [].concat($scope.data.listData);
		}
	};
	/**
	 * [initDropDownList description] 初始化下拉菜单
	 * @return {[type]} [description]
	 */
	function initDropDownList() {
		$scope.status.statusOptions = [{
			name: "全部状态",
			value: ''
		}, {
			name: "允许投稿",
			value: 1,
		}, {
			name: "停止投稿",
			value: 0
		}];
		$scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
	};
	/**
	 * [initStatus description] 初始化数据
	 * 
	 */
	$scope.requestData = function() {
		requestData();
	}

	function requestData() {
		var params = {
			id: $scope.data.classId,
			status: $scope.status.selectedStatus.value,
			currPage: $scope.page.CURRPAGE,
			pageSize: $scope.page.PAGESIZE
		}
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/classic/list.do", params, "post").then(function(data) {
			$scope.data.listData = data.data.ldata;
			$scope.page = {
				CURRPAGE: data.data.startPage,
				PAGESIZE: data.data.pageSize,
				ITEMCOUNT: data.data.totalResults,
				PAGECOUNT: data.data.totalPages
			};
		});
	}

	/**
	 * [synchro description] 同步所有的投稿分类
	 * @param  {[type]} items [description] 当前面板
	 * @return {[type]}       [description]
	 */
	$scope.synchro = function() {
		modalDialog.backConfirmModal("同步", "确认与"+$scope.platformName+"同步？", function() {
			httpService.http("/mcnadmin/admin/classic/synchro.do", '', "post").then(function(data) {
				modalDialog.alertType('', '同步成功', 'success');
				requestData();
			});
		});
	}
	/**
	 * [allow description] 允许投稿
	 * @param  {[type]}  [description] 
	 * @return {[type]}  [description]
	 */
	$scope.allow = function(id) {
		var params = {
			ids: "",
		}
		if(id) {
			params.ids = id;
		} else {
			var params = {
				ids: angular.packageIds($scope.data.selectedArray, ",", "id")
			}
		}

		modalDialog.backConfirmModal("允许投稿", "确认允许已选分类投稿？", function() {
			httpService.http("/mcnadmin/admin/classic/allowStatus.do", params, "post").then(function(data) {
				modalDialog.alertType('', '允许投稿成功', 'success');
				requestData();
			});
		});
	}
	/**
	 * [stop description] 停止投稿
	 * @param  {[type]}  [description]
	 * @return {[type]}  [description]
	 */
	$scope.stop = function(id) {
		var params = {
			ids: "",
		}
		if(id) {
			params.ids = id;
		} else {
			var params = {
				ids: angular.packageIds($scope.data.selectedArray, ",", "id")
			}
		}
		modalDialog.backConfirmModal("停止投稿", "确认停止已选分类投稿？", function() {
			httpService.http("/mcnadmin/admin/classic/stopStatus.do", params, "post").then(function(data) {
				modalDialog.alertType('', '停止投稿成功', 'success');
				requestData();
			});
		});
	}
}]);
